import BaseStore from 'fluxible/addons/BaseStore';
import Actions from '../constants/Actions';
var cookie = require('react-cookie');

class LoginStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.login = [];
  }
  handleSessionUpdateSuccess(data) {
    var date = new Date();
    var days = days || 365;
    date.setTime(+date + (days * 86400000));
    this.login = data;
    if (data.is_fb_login === 1) {
      this.login.logged_in = 2;
    } else {
      this.login.logged_in = 1;
    }
    cookie.save('logged_in', this.login.logged_in, {
      expires: date,
      httpOnly: false,
      path: '/'
    });
    cookie.save('username', this.login.folink_username, {
      expires: date,
      httpOnly: false,
      path: '/'
    });
    if (this.login.name) {
      cookie.save('username', this.login.name, {
        expires: date,
        httpOnly: false,
        path: '/'
      });
    }
    cookie.save('id', this.login.id, {
      expires: date,
      httpOnly: false,
      path: '/'
    });
    this.emitChange();
  }
  handleLogoutSuccess() {
    this.login.username = 0;
    this.login.logged_in = 0;
    this.login.id = 0;
    cookie.save('id', this.login.id, {
      path: '/'
    });
    cookie.save('logged_in', this.login.logged_in, {
      path: '/'
    });
    cookie.save('username', this.login.username, {
      path: '/'
    });
    this.emitChange();
  }
  get() {
    return {
      username: cookie.load('username'),
      logged_in: cookie.load('logged_in'),
      id: cookie.load('id')
    };
  }

  dehydrate() {
    return {
      logindata: this.login
    };
  }

  rehydrate(state) {
    this.login = state.login;
  }
}

LoginStore.storeName = 'LoginStore';
LoginStore.handlers = {
  [Actions.SESSION_UPDATE_SUCCESS]: 'handleSessionUpdateSuccess',
  [Actions.LOGOUT_SUCCESS]: 'handleLogoutSuccess'
};

export default LoginStore;


// WEBPACK FOOTER //
// ./src/stores/LoginStore.js